import ReactGA from 'react-ga4';
import { GA_MEASUREMENT_ID } from '../../../env';

import { User } from '@esg/esg-global-types';

// Keep a global user reference.
let current_user: User | null = null;

/**
 * Sets or clears the current analytics user.
 * @param {User | null} user User to associate with events, or `null` to clear.
 */
export const setAnalyticsUser = (user: User | null) => {
  current_user = user;
};

/**
 * Initializes Google Analytics 4 (GA4) tracking using the provided measurement ID.
 * @returns {void}
 */
export const initGA = (): void => {
  ReactGA.initialize(
    GA_MEASUREMENT_ID /*, {
    gaOptions: {
      debug_mode: true // enables debug mode
    }
  }*/
  );
};

/**
 * Tracks a page view in GA4.
 * @param {string} path The path of the page to track.
 * @returns {void}
 */
export const trackPageView = (path: string): void => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

/**
 * Sends a custom event to GA4.
 * @param {string} event_name The name of the event.
 * @param {Record<string, unknown>} [params={}] Optional parameters to provide additional context for the event.
 * @returns {void}
 */
export const trackEvent = (
  event_name: string | 'module_visit',
  params: Record<string, unknown> = {},
  include_user = true
): void => {
  const staged_params: Record<string, unknown> = include_user
    ? {
        ...params,
        syntiro_user_id: current_user?.id ?? null,
        syntiro_user_email: current_user?.email ?? null
      }
    : params;
  ReactGA.event(event_name, staged_params);
};
